// Convert string to base64
// 字符串转 base64
const _encodeBase64 = function (str) {
  // Encode a string
  // 对字符串进行编码
  const encode = encodeURI(str)
  // Convert encoded string base64
  // 对编码的字符串转化 base64
  const base64 = btoa(encode)
  return base64
}

// Base64 to string
// base64 转字符串
const _decodeBase64 = function (base64) {
  // Transcoding base64
  // 对 base64 转编码
  const decode = atob(base64)
  // Encoding to String
  // 编码转字符串
  const str = decodeURI(decode)
  return str
}

export {
  _encodeBase64,
  _decodeBase64
}